export default {
  operation: {
    plural: {
      itself: 'Operations',
    },
  },
};
